import React from "react";
import { Route, Redirect } from "react-router";
import { connect } from "react-redux";
import lodash from "lodash";
import moment from "moment-timezone";
import axios from "axios";
import config from "../config";
import * as action from "../actions";
import { logEvent, getUserStatus, getUserStatusV2 } from "../api";
import { hasRevenueCatSub } from "../utils/common";

class ProtectedRouteCardio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      isAuthChecked: this.props.isAuthCheck || false,
      cardio_access:  this.props.cardio_access || false,
    };
  }
  async _getUserStatus(user) {

    const calendarData = {
      weekStart: moment()
        .tz(user.timezone || config.defaultTimezone)
        .clone()
        .startOf("isoWeek"),
      weekEnd: moment()
        .tz(user.timezone || config.defaultTimezone)
        .clone()
        .endOf("isoWeek"),
      monthEnd: moment()
        .tz(user.timezone || config.defaultTimezone)
        .clone()
        .endOf("month"),
      monthStart: moment()
        .tz(user.timezone || config.defaultTimezone)
        .clone()
        .startOf("month"),
    };
    const weekFrom = moment(calendarData.weekStart)
      .tz(user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const weekTo = moment(calendarData.weekEnd)
      .tz(user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const monthFrom = moment(calendarData.monthStart)
      .tz(user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const monthTo = moment(calendarData.monthEnd)
      .tz(user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const userStatus = await getUserStatusV2({
      uid: user.uid,
      accountType: user.accountType,
      affiliateLinkId: user.affiliateLinkId,
      weekFrom,
      weekTo,
      monthFrom,
      monthTo,
    });
    return userStatus
  }
  componentDidMount() {
    axios
      .get(`${config.backend_url}/isAuth`)
      .then( async (res) => {
        const userStatus = await this._getUserStatus(res.data.user);
        this.props.updateUser({ ...res.data.user, userStatus, hasRevenueCatSub: hasRevenueCatSub(userStatus) });
          this.setState({ user: res.data.user, cardio_access: res.data.user.cardio_access });
          window.addEventListener("error", async (event) => {
            // LOG ERROR EVENT HERE
            const payload = {
                type: 'ErrorEvent',
                uid: this.props?.user?.uid,
                url: this.props?.location?.pathname,
                filename: event?.filename,
                line_no: event?.lineno,
                message: event?.message,
                errorMessage: event?.error?.message,
                stack: event?.error?.stack,
  
                currentUrl: this.props?.location?.pathname,
                screenHeight: window.innerHeight,
                screenWidth: window.innerWidth
            }
            await logEvent(payload);
          });
      })
      .catch((err) => {})
      .finally(() => {
        this.setState({ isAuthChecked: true });
      });
  }
  render() {
    if (this.state.isAuthChecked) {
      if (!lodash.isEmpty(this.state.user) && this.state.cardio_access && this.state.user?.agreement?.privacyPolicy) {
        if(!this.state.user?.agreement?.ageAgreed) {
          return (
            <Redirect
            to={{
              pathname: "/update-tnc",
              state: { from: this.props.location },
            }}
          />
          )
        }
        if(!this.state.user?.verified) {
          return (
            <Redirect
              to={{
                pathname: `/verify`,
                search: `?uid=${this.state.user.uid}`,
                state: { from: this.props.location },
              }}
            />
          )
        }
        return (
          <Route
            {...this.props}
            render={(newProps) => {
              const { comp: Component } = this.props;
              return <Component {...newProps} />;
            }}
          />
        );
        
      } else {
        return (
          <Redirect
            to={{
              pathname: "/home",
              state: { from: this.props.location },
            }}
          />
        );
      }
    } else {
      return <div className="init-render"></div>;
    }
  }
}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (user) => dispatch(action.updateUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRouteCardio);
